import { MailIcon } from '@heroicons/react/outline'
import { PhoneIcon } from '@heroicons/react/solid'
import { fetchClients } from 'api'
import { useAsyncMemo } from 'hooks'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useVonage } from '../../context/vonage'
import SearchBar from '../SearchBar'
import VonageCallButton from '../Vonage/VonageCallButton'
import Drawer from './Drawer'
import FloatButton from './FloatButton'

const CallDrawer = () => {
  const [openDrawer, setOpenDrawer] = useState(false)
  const [params, setParams] = useState({
    email: '',
    phone: '',
  })

  const [matters] = useAsyncMemo(async () => {
    const { body, error } = await fetchClients()
    if (error || !body) return []
    return body
  }, [])

  const { showContactPad, setShowContactPad, vonageLoaded } = useVonage()

  const { push } = useRouter()

  if (!vonageLoaded || !matters) return null

  return (
    <div>
      {' '}
      <FloatButton
        color="default"
        fixed
        size="small"
        icon={<PhoneIcon />}
        onClick={() => {
          setOpenDrawer(true)
        }}
      >
        Call
      </FloatButton>
      <Drawer
        title="Call a client"
        onClose={() => {
          setOpenDrawer(false)
          setShowContactPad(false)
        }}
        anchor="right"
        open={openDrawer}
      >
        <div className="px-8 pt-7">
          <div className="flex items-center">
            <SearchBar
              placeholder="Search by Phone Number"
              iconClassName="text-[#3F3E3E]"
              value={params.phone}
              onChange={e => {
                setParams({ ...params, phone: e.target.value })
              }}
            />
            {vonageLoaded && (
              <button
                type="button"
                className="cursor-pointer rounded-full p-3 hover:bg-gray-100"
                onClick={() => {
                  setShowContactPad(!showContactPad)
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 23C11.45 23 10.9793 22.8043 10.588 22.413C10.196 22.021 10 21.55 10 21C10 20.45 10.196 19.979 10.588 19.587C10.9793 19.1957 11.45 19 12 19C12.55 19 13.021 19.1957 13.413 19.587C13.8043 19.979 14 20.45 14 21C14 21.55 13.8043 22.021 13.413 22.413C13.021 22.8043 12.55 23 12 23ZM6 5C5.45 5 4.97933 4.804 4.588 4.412C4.196 4.02067 4 3.55 4 3C4 2.45 4.196 1.979 4.588 1.587C4.97933 1.19567 5.45 1 6 1C6.55 1 7.02067 1.19567 7.412 1.587C7.804 1.979 8 2.45 8 3C8 3.55 7.804 4.02067 7.412 4.412C7.02067 4.804 6.55 5 6 5ZM6 11C5.45 11 4.97933 10.804 4.588 10.412C4.196 10.0207 4 9.55 4 9C4 8.45 4.196 7.979 4.588 7.587C4.97933 7.19567 5.45 7 6 7C6.55 7 7.02067 7.19567 7.412 7.587C7.804 7.979 8 8.45 8 9C8 9.55 7.804 10.0207 7.412 10.412C7.02067 10.804 6.55 11 6 11ZM6 17C5.45 17 4.97933 16.8043 4.588 16.413C4.196 16.021 4 15.55 4 15C4 14.45 4.196 13.979 4.588 13.587C4.97933 13.1957 5.45 13 6 13C6.55 13 7.02067 13.1957 7.412 13.587C7.804 13.979 8 14.45 8 15C8 15.55 7.804 16.021 7.412 16.413C7.02067 16.8043 6.55 17 6 17ZM18 5C17.45 5 16.979 4.804 16.587 4.412C16.1957 4.02067 16 3.55 16 3C16 2.45 16.1957 1.979 16.587 1.587C16.979 1.19567 17.45 1 18 1C18.55 1 19.021 1.19567 19.413 1.587C19.8043 1.979 20 2.45 20 3C20 3.55 19.8043 4.02067 19.413 4.412C19.021 4.804 18.55 5 18 5ZM12 17C11.45 17 10.9793 16.8043 10.588 16.413C10.196 16.021 10 15.55 10 15C10 14.45 10.196 13.979 10.588 13.587C10.9793 13.1957 11.45 13 12 13C12.55 13 13.021 13.1957 13.413 13.587C13.8043 13.979 14 14.45 14 15C14 15.55 13.8043 16.021 13.413 16.413C13.021 16.8043 12.55 17 12 17ZM18 17C17.45 17 16.979 16.8043 16.587 16.413C16.1957 16.021 16 15.55 16 15C16 14.45 16.1957 13.979 16.587 13.587C16.979 13.1957 17.45 13 18 13C18.55 13 19.021 13.1957 19.413 13.587C19.8043 13.979 20 14.45 20 15C20 15.55 19.8043 16.021 19.413 16.413C19.021 16.8043 18.55 17 18 17ZM18 11C17.45 11 16.979 10.804 16.587 10.412C16.1957 10.0207 16 9.55 16 9C16 8.45 16.1957 7.979 16.587 7.587C16.979 7.19567 17.45 7 18 7C18.55 7 19.021 7.19567 19.413 7.587C19.8043 7.979 20 8.45 20 9C20 9.55 19.8043 10.0207 19.413 10.412C19.021 10.804 18.55 11 18 11ZM12 11C11.45 11 10.9793 10.804 10.588 10.412C10.196 10.0207 10 9.55 10 9C10 8.45 10.196 7.979 10.588 7.587C10.9793 7.19567 11.45 7 12 7C12.55 7 13.021 7.19567 13.413 7.587C13.8043 7.979 14 8.45 14 9C14 9.55 13.8043 10.0207 13.413 10.412C13.021 10.804 12.55 11 12 11ZM12 5C11.45 5 10.9793 4.804 10.588 4.412C10.196 4.02067 10 3.55 10 3C10 2.45 10.196 1.979 10.588 1.587C10.9793 1.19567 11.45 1 12 1C12.55 1 13.021 1.19567 13.413 1.587C13.8043 1.979 14 2.45 14 3C14 3.55 13.8043 4.02067 13.413 4.412C13.021 4.804 12.55 5 12 5Z"
                    fill="black"
                  />
                </svg>
              </button>
            )}
          </div>
          {/* //client search results */}
          {matters.length > 0 ? (
            <div className="mt-8 flex flex-col">
              {matters.map(matter => (
                <div className="flex w-full flex-col  items-center  justify-between border-b py-4 sm:flex-row">
                  <div className="flex flex-col items-start justify-between gap-4">
                    <div className="text-sm font-semibold">
                      {matter.full_name}
                    </div>
                    <div className="flex flex-col items-start text-sm">
                      <button
                        type="button"
                        onClick={() => {
                          push(`/tm/clients/${matter.id}`)
                          setOpenDrawer(false)
                        }}
                        className="text-primary hover:underline"
                      >
                        View more
                      </button>
                      <span className="flex gap-2 break-words break-all">
                        <MailIcon className="text-primary h-6 w-6" />
                        {matter.email}
                      </span>
                    </div>
                  </div>
                  <div className=" flex flex-col  items-end justify-between gap-4">
                    <div className="text-sm font-medium">{matter.phone}</div>

                    <div>
                      <VonageCallButton
                        phoneNumber={matter.phone}
                        className="bg-primary flex items-center gap-2 rounded-lg px-4 py-2 text-white"
                        clientName={matter.full_name}
                      >
                        <PhoneIcon className="h-5 w-5 text-white" />
                        <p className="font-semibold">Call</p>
                      </VonageCallButton>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="mt-8 flex flex-col items-center justify-center">
              <div className="text-center text-sm font-semibold">
                No results found{' '}
                <button
                  type="button"
                  className="text-primary"
                  onClick={() => {
                    push('/tm/client_management?client_status="my_clients"')
                  }}
                >
                  See your clients
                </button>
              </div>
            </div>
          )}
        </div>
      </Drawer>
    </div>
  )
}

export default CallDrawer
